// Views
import HrLayout from "../../Views/Hr/Layout";
import Contracts from "../../Views/Hr/Contracts";
import HoursTotals from "../../Views/Hr/HoursTotals";
import Timeregistration from "../../Views/Hr/Timeregistration";

// Router files
import HrUsersRoutes from './users';
import HrUsergroupsRoutes from './usergroups';
import HrTeamsRoutes from './teams';

export default [
    {
        path:'/hr',
        redirect:'/hr/users',
        name:'hr.index',
        component:HrLayout,
        children:[
            ...HrUsersRoutes,
            ...HrUsergroupsRoutes,
            ...HrTeamsRoutes,
            {
                path:'/hr/contracts',
                component:Contracts,
                name:'hr.contracts.index',
            },
            {
                path:'/hr/timeregistration',
                component:Timeregistration,
                name:'hr.timeregistration.index',
            },
            {
                path:'/hr/hours/totals',
                component:HoursTotals,
                name:'hr.hours.totals',
            },
        ]
    },
];
